"use strict";

exports.__esModule = true;
exports.default = _default;

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _ClearAll = _interopRequireDefault(require("@material-ui/icons/ClearAll"));

var _SortByAlpha = _interopRequireDefault(require("@material-ui/icons/SortByAlpha"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));

var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _react = _interopRequireDefault(require("react"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Filter = require("material-ui-shell/lib/providers/Filter");

var _reactIntl = require("react-intl");

var _Scrollbar = _interopRequireDefault(require("material-ui-shell/lib/components/Scrollbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(_ref) {
  var name = _ref.name,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 250 : _ref$width,
      _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields;
  var intl = (0, _reactIntl.useIntl)();

  var _useFilter = (0, _Filter.useFilter)(),
      isFilterOpen = _useFilter.isFilterOpen,
      closeFilter = _useFilter.closeFilter,
      clearFilter = _useFilter.clearFilter,
      getFilter = _useFilter.getFilter,
      removeFilterQuery = _useFilter.removeFilterQuery,
      editFilterQuery = _useFilter.editFilterQuery,
      addFilterQuery = _useFilter.addFilterQuery,
      setFilterSortField = _useFilter.setFilterSortField,
      setFilterSortOrientation = _useFilter.setFilterSortOrientation,
      getField = _useFilter.getField;

  var _getFilter = getFilter(name),
      _getFilter$queries = _getFilter.queries,
      queries = _getFilter$queries === void 0 ? [] : _getFilter$queries,
      _getFilter$sortField = _getFilter.sortField,
      sortField = _getFilter$sortField === void 0 ? '' : _getFilter$sortField,
      _getFilter$sortOrient = _getFilter.sortOrientation,
      sortOrientation = _getFilter$sortOrient === void 0 ? 1 : _getFilter$sortOrient;

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Drawer.default, {
    variant: "persistent",
    anchor: "right",
    open: isFilterOpen(name)
  }, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    position: "static"
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
    disableGutters: true
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    color: "inherit",
    onClick: function onClick() {
      return closeFilter(name);
    }
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null)), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6",
    color: "inherit"
  }, intl.formatMessage({
    id: 'filter',
    defaultMessage: 'Filter'
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: 1
    }
  }), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    color: "inherit",
    onClick: function onClick() {
      return clearFilter(name);
    }
  }, /*#__PURE__*/_react.default.createElement(_ClearAll.default, null)))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: width,
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: 8,
      display: 'flex',
      flexDirection: 'row'
    }
  }, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    variant: "outlined",
    fullWidth: true,
    style: {
      padding: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    value: sortField,
    onChange: function onChange(e) {
      setFilterSortField(name, e.target.value);
    },
    displayEmpty: true
  }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    key: 'none',
    value: ''
  }, intl.formatMessage({
    id: 'none',
    defaultMessage: 'None'
  })), fields.map(function (f) {
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      key: f.name,
      value: f.name
    }, f.label);
  }))), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    color: sortOrientation === 1 ? 'primary' : 'secondary',
    disabled: sortField === '' || !sortField,
    onClick: function onClick() {
      return setFilterSortOrientation(name, sortOrientation === 1 ? -1 : 1);
    }
  }, /*#__PURE__*/_react.default.createElement(_SortByAlpha.default, null))), /*#__PURE__*/_react.default.createElement(_Divider.default, null), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6",
    color: "inherit"
  }, intl.formatMessage({
    id: 'filter',
    defaultMessage: 'Filter'
  })), /*#__PURE__*/_react.default.createElement(_Fab.default, {
    size: "small",
    onClick: function onClick() {
      return addFilterQuery(name, {
        field: '',
        operator: '=',
        value: ''
      });
    },
    color: "primary",
    "aria-label": "add"
  }, /*#__PURE__*/_react.default.createElement(_Add.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: '100%',
      flex: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_Scrollbar.default, null, queries.map(function (q, i) {
    var field = getField(q.field, fields);
    return /*#__PURE__*/_react.default.createElement("div", {
      key: q.field + "_" + i,
      style: {
        padding: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
      variant: "outlined",
      fullWidth: true,
      style: {
        padding: 1
      }
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      value: q.field,
      onChange: function onChange(e) {
        var _getField = getField(e.target.value, fields),
            defaultOperator = _getField.defaultOperator;

        return editFilterQuery(name, i, _extends(_extends({}, q), {}, {
          field: e.target.value,
          operator: defaultOperator
        }));
      },
      displayEmpty: true
    }, fields.map(function (f) {
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        key: f.name,
        value: f.name
      }, f.label);
    }))), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }
    }, field && /*#__PURE__*/_react.default.createElement(_FormControl.default, {
      variant: "outlined",
      style: {
        padding: 1,
        minWidth: 100
      }
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      value: q.operator,
      onChange: function onChange(e) {
        return editFilterQuery(name, i, _extends(_extends({}, q), {}, {
          operator: e.target.value
        }));
      },
      displayEmpty: true
    }, field.operators.map(function (o) {
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        key: o.value,
        value: o.value
      }, o.label);
    }))), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      onClick: function onClick() {
        return removeFilterQuery(name, i);
      }
    }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
      color: "error"
    }))), field && field.render(q, function (changes) {
      return editFilterQuery(name, i, _extends(_extends({}, q), changes));
    }), /*#__PURE__*/_react.default.createElement(_Divider.default, {
      style: {
        marginTop: 6
      }
    }));
  }))))));
}

module.exports = exports.default;